// extracted by mini-css-extract-plugin
export default {"pdd_wiev":"Pdd_pdd_wiev__Pi2dV","pdd_heading":"Pdd_pdd_heading__+VVNJ","list":"Pdd_list__WQekO","theme_item":"Pdd_theme_item__zTVk8"};